/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxGamesLibWebRpcContractsResponseError, FxGamesLibWebRpcContractsResponseErrorFromJSONTyped, FxGamesLibWebRpcContractsResponseErrorToJSON, } from './FxGamesLibWebRpcContractsResponseError';
export function FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxGamesLibWebRpcContractsResponseError(json)) {
        return FxGamesLibWebRpcContractsResponseErrorFromJSONTyped(json, true);
    }
    return {};
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxGamesLibWebRpcContractsResponseError(value)) {
        return FxGamesLibWebRpcContractsResponseErrorToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError.js.map